/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $StatisticV2 = {
    properties: {
        key: {
            type: 'StatisticKeyEnum',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        pro: {
            type: 'boolean',
            isRequired: true,
        },
        extraText: {
            type: 'any-of',
            contains: [{
                type: 'Translation',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        unit: {
            type: 'FrontendUnit',
            isRequired: true,
        },
    },
} as const;
